import { createFileRoute } from '@tanstack/react-router';
import ImportCreateView from '../bulk-import/imports/create/import-create-view';
export const Route = createFileRoute('/bulk-import/imports/create')({
  component: ImportCreateView,
});
